import { saveAs } from 'file-saver';
import { isEmpty } from 'lodash-es';
import {
  getPresignedURLForGet,
  getResumePreview,
  getCandidateByCVUrl,
  trackCVView,
  downloadCvAsPDF,
  IJob,
} from 'wisestep-api';

const imageValidator = /\.(jpeg|jpg|gif|png)$/;

export const filterS3Url = async (s3url: string) => {
  try {
    const isImage = imageValidator.test(s3url);
    if (isImage) {
      const url = await getPresignedURLForGet({ fileName: s3url, downloadAs: 'image' });
      return { url: url.data.preSignedUrl, type: 'image' };
    }
    const url = await getResumePreview(s3url.split('?')[0], '');
    return { url: url.data.preSignedUrl, type: 'notImage' };
  } catch (e) {
    return null;
  }
};

export const downloadCV = async (s3url: string, fileName?: string) => {
  const downloadAs = fileName?.split('/').slice(-1)[0]?.split('.')[0] ?? 'candidate';
  if (!isEmpty(fileName?.split('.').slice(-1)[0]) && fileName?.split('.').slice(-1)[0] == 'html') {
    const downloadName = `${fileName?.split('/').slice(-1)[0].split('.')[0]}.pdf`;
    const downloadDetails = await downloadCvAsPDF({
      fileName: s3url?.split('/').slice(-1)[0],
      downloadAs: downloadName,
    });
    const headers = downloadDetails.headers;
    const file = new Blob([downloadDetails.data], {
      type: headers['content-type'],
    });
    saveAs(file, downloadName);
  } else {
    const url = await getPresignedURLForGet({ fileName: s3url, downloadAs: downloadAs });
    window.open(url.data.preSignedUrl, '_blank');
  }
};

export enum ITrackCvViewJobBoards {
  DICESEARCH = 'Nativesearch_DICESEARCH',
  CareerBuilderRDB = 'Nativesearch_Career_Builder RDB',
  CareerBuilderEDGE = 'Nativesearch_Career_Builder_EDGE',
  TECHFETCHSEARCH = 'Nativesearch_TECHFETCHSEARCH',
  MONSTER_US = 'Nativesearch_MONSTER_US',
  MONSTER_EU = 'Nativesearch_MONSTER_EU',
  MONSTER_CA = 'Nativesearch_MONSTER_CA',
  CWJOBSSEARCH = 'Nativesearch_CWJOBS_SEARCH',
  JOBSERVESEARCH = 'Nativesearch_JOBSERVE_SEARCH',
  CVLIBRARYSEARCH = 'Nativesearch_CVLIBRARY_SEARCH',
  JOBSITESEARCH = 'Nativesearch_JOBSITE_SEARCH',
  RESUMELIBRARYSEARCH = 'Nativesearch_RESUMELIBRARY_SEARCH',
}

export enum ITrackCvPages {
  WISESTEP = 'WiseStep',
  JOBCRM_APPLICATION = 'JOBCRM_Application',
  JOBCRM_MAPPINGS = 'JOBCRM_Mapping',
  JOBCRM_SUBMISSION = 'JOBCRM_Submission',
  JOBCRM_UPLOAD = 'JOBCRM_Upload',
  JOBCRM_AI_SUGGESTIONS = 'JOBCRM_AI_Suggestions',
  JOBCRM_SIMILAR_JOBS = 'JOBCRM_Similar_Jobs',
  PIPELINE = 'Pipeline',
  TALENTPOOL = 'Talentpool',
  SUBMISSION = 'Submission',
}

export const trackCV = async (action, url, page: string, job?: IJob) => {
  const req = await getCandidateByCVUrl({
    s3URL: url,
  });
  const candidate = req.data;

  const cvView = {
    key: '',
    name: candidate.name,
    site: 'WiseStep',
    page: page ?? ITrackCvPages.WISESTEP,
    source: 'WiseStep',
    action: action,
    jobCode: job?.jobCode ?? '',
    jobTitle: job?.title ?? '',
    mappingEntityId: isEmpty(candidate?.candidateStatusTags) ? '' : candidate?.id,
  };
  if (!isEmpty(candidate.email)) {
    cvView.key = candidate.email.trim();
  } else if (!isEmpty(candidate?.alternateEmails)) {
    cvView.key = candidate.alternateEmails[0].trim();
  } else if (!isEmpty(candidate.linkedInURL)) {
    cvView.key = candidate.linkedInURL.trim();
  } else if (!isEmpty(candidate.profileURLs)) {
    cvView.key = candidate.profileURLs[0].trim();
  }
  trackCVView(cvView);
};

export const cvViewAndDownload = (
  action: string,
  url: string | null,
  fileName: string,
  cvViewSourcePage: ITrackCvPages | ITrackCvViewJobBoards
) => {
  switch (action) {
    case 'view':
      url && trackCV('view', url, cvViewSourcePage);
      break;
    case 'download':
      if (!isEmpty(url)) {
        trackCV('download', url, cvViewSourcePage);
        url && downloadCV(url.split('?')[0], fileName);
      }
      break;
  }
};
